export type ProjectionViewMode = "annual" | "quarter";

// Minimum number of forward estimate points required before we render the chart.
// Below this we show a "not enough coverage" message instead of a sparse chart.
export const MIN_ANNUAL_PROJECTION_POINTS = 3;
export const MIN_QUARTER_PROJECTION_POINTS = 3;

// Cap individual bar width (px) so a series with only a few points doesn't render
// as comically wide bars when it first loads.
export const PROJECTION_MAX_BAR_WIDTH = 64;

export const getMinProjectionPoints = (viewMode: ProjectionViewMode): number =>
  viewMode === "annual"
    ? MIN_ANNUAL_PROJECTION_POINTS
    : MIN_QUARTER_PROJECTION_POINTS;
